/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Shared_WaitInputs */

const en_admin_shared_wait = /** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait…`)
};

const de_admin_shared_wait = /** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte warten…`)
};

const es_admin_shared_wait = /** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espera un momento…`)
};

const fr_admin_shared_wait = /** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez patienter…`)
};

const nl_admin_shared_wait = /** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Even geduld…`)
};

/** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */
const it_admin_shared_wait = en_admin_shared_wait;

/** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */
const pt_br2_admin_shared_wait = en_admin_shared_wait;

/** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */
const pl_admin_shared_wait = en_admin_shared_wait;

/** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */
const hu_admin_shared_wait = en_admin_shared_wait;

/** @type {(inputs: Admin_Shared_WaitInputs) => LocalizedString} */
const ro_admin_shared_wait = en_admin_shared_wait;

/**
* | output |
* | --- |
* | "Please wait…" |
*
* @param {Admin_Shared_WaitInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_wait = /** @type {((inputs?: Admin_Shared_WaitInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_WaitInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_wait(inputs)
	if (locale === "de") return de_admin_shared_wait(inputs)
	if (locale === "es") return es_admin_shared_wait(inputs)
	if (locale === "fr") return fr_admin_shared_wait(inputs)
	if (locale === "nl") return nl_admin_shared_wait(inputs)
	if (locale === "it") return it_admin_shared_wait(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_wait(inputs)
	if (locale === "pl") return pl_admin_shared_wait(inputs)
	if (locale === "hu") return hu_admin_shared_wait(inputs)
	return ro_admin_shared_wait(inputs)
});
export { admin_shared_wait as "admin.shared.wait" }